export const getIdClientFromChat = (chat) => {
  return chat?.cliente?.id || chat?.cliente?.id_postgres || undefined;
};
